 <template>
 	<div class="banner dispensary">
		<div class="level container has-text-centered-mobile is-vcentered">
			<div class="level-left">
				<div class="level-item">
					<figure class="image is-64x64 dispensary-avatar" v-if="settings.avatarUrl">
					  	<base-image alt="dispensary avatar" class="is-rounded" :src="settings.avatarUrl" />
					</figure>
					<nav class="breadcrumb" aria-label="Navigation breadcrumb">
						<ul>
							<li v-for="breadcrumb in breadcrumbs">
							<base-link :href="breadcrumb.url" :aria-label="`Go to ${breadcrumb.label}`" :title="breadcrumb.label">
                               {{ breadcrumb.label }}
							</base-link></li>
						</ul>
					</nav>
					<h2 class="title is-2">{{ settings.name }}</h2>
				</div>
			</div>
		</div>

		<div class="container dispensary-tabs">
			<ul>
				<li>
				 <base-link :href="settings.shopUrl" :class="{ active: isShopActive }" aria-label="Shop" title="Shop">
                   Shop
                 </base-link>
				</li>
				<li v-if="showAboutTab">
					<base-link :href="settings.aboutUrl" :class="{ active: isAboutActive }" aria-label="About" title="About">
					  About
					</base-link> 
				   <span class="tag is-rounded is-success">New</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: "DispensaryBanner",
	props: {
		settings: { type: Object, required: true },
	    breadcrumbs: { type: Array, default() { return []; } },
	},
	
	computed: {
		isShopActive() {
			return !this.isAboutActive;
		},
		
		isAboutActive() {
			return window.location.href.indexOf("/about") > -1;
		},
		
		showAboutTab() {
			return this.settings.showAboutPage;
		}
	}
}
</script>

<style lang="scss" scoped>
	// To do after Nuxt, do not have variables and mixins accessible
</style>